/*
 * @Author       : he bo
 * @Date         : 2021-02-26 11:37:07
 * @LastEditors: DG
 * @LastEditTime: 2022-02-25 15:52:51
 * @FilePath     : /fe-ts-basic-platform/src/routers/Menus.jsx
 */
import React, { useMemo } from 'react';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { Layout, Menu } from 'antd';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { get } from 'lodash';
import routes from './index';
import { getStationCode } from '@/utils/cookie';
import styles from './menu.module.less';

const { SubMenu, Item } = Menu;

const getAuth = (authList, access) => {
  if (!access) {
    return true;
  }
  return get(authList, access);
};

const generateMenu = (routes, authList, currentStationInfo, restProps) => {
  const { accountInfo, ...menuProps } = restProps;
  return routes.map((r) => {
    if (!r.routes && r.openNewTab) {
      // 打开新页面
      return (
        <Item {...menuProps} key={r.path}>
          <a
            id={`longan-【菜单点击】-${r.title}`}
            data-longan={`${accountInfo.accountName}(${accountInfo.accountId})- ${
              currentStationInfo.stationName
            }`}
            to={r.path}
            href={`${r.path}?code=${getStationCode()}`}
            target="_blank"
            rel="noreferrer"
          >
            {r.icon && <LegacyIcon type={r.icon} />}
            <span>{r.title}</span>
          </a>
        </Item>
      );
    }
    if (!r.routes) {
      // 不存在子路由
      return getAuth(authList, r.access) &&
        (!r.conditions ||
          (r.conditions &&
            Object.keys(r.conditions).every(
              (key) => currentStationInfo[key] === r.conditions[key],
            ))) ? (
        <Item {...menuProps} key={r.path}>
          <Link
            id={`longan-【菜单点击】-${r.title}`}
            data-longan={`${accountInfo.accountName}(${accountInfo.accountId})- ${
              currentStationInfo.stationName
            }`}
            to={r.path}
          >
            {r.icon && <LegacyIcon type={r.icon} />}
            <span>{r.title}</span>
          </Link>
        </Item>
      ) : null;
    }
    const ignoreHideMenu = r.routes.filter((item) => {
      if (item.hideInMenu) return false;
      return true;
    });
    const childs = generateMenu(ignoreHideMenu, authList, currentStationInfo, restProps);

    return childs.filter(Boolean).length ? (
      <SubMenu
        {...menuProps}
        key={r.path}
        title={
          <>
            {r.icon && <LegacyIcon type={r.icon} />}
            <span>{r.title}</span>
          </>
        }
      >
        {childs}
      </SubMenu>
    ) : null;
  });
};

const Menus = (props) => {
  const { authList, openKeys, dispatch, selectedKeys, currentStationInfo, ...restProps } = props;

  const len = Object.keys(authList).length;

  const menu = useMemo(() => {
    return generateMenu(routes, authList, currentStationInfo, restProps);
  }, [authList, currentStationInfo]);

  if (!len) {
    return [];
  }
  const onOpenChange = (openKeys) => {
    dispatch({ type: 'CHANGE_PATH', payload: openKeys.slice(-1) });
  };

  const onSelect = ({ key }) => {
    dispatch({ type: 'CHANGE_PATH', payload: [`/${key.split('/')[1]}`] });
  };
  // console.log('props',props, generateMenu(routes, authList))
  return (
    <Menu
      theme="dark"
      mode="inline"
      className={styles.menu}
      openKeys={openKeys}
      onOpenChange={onOpenChange}
      onSelect={onSelect}
      selectedKeys={selectedKeys}
    >
      {menu}
    </Menu>
  );
};

const mapStateToProps = (state, base) => {
  const {
    basic: { authList, openKeys, selectedKeys, accountInfo, currentStationInfo },
  } = state;
  return {
    authList,
    openKeys,
    selectedKeys,
    accountInfo,
    currentStationInfo,
  };
};

export default connect(mapStateToProps)(Menus);
